// extracted by mini-css-extract-plugin
module.exports = {"search-fade-in":"PeopleLanguages_search-fade-in__w75EM"};